module.exports = __webpack_public_path__ + "img/holidays.c87ccc7c.png";